import React, { useContext } from 'react'
import Grid from '@material-ui/core/Grid'
import { Field } from 'react-final-form'
import { AuthContext, CrudForm, TextField, useEntityManager } from 'elentari'
import { parseTelefone } from '../../utils/Parse'
import usuariosRepository from './UsuariosRepository'
import { Email } from '../../components'
import { useHistory, useParams } from 'react-router-dom'

const UsuarioSimpleForm = props => {
  const history = useHistory()
  const params = useParams()
  const id = +params.id
  const { user } = useContext(AuthContext)

  if (id !== user.id) {
    history.goBack()
  }
  const entityManager = useEntityManager({ repository: usuariosRepository })

  const handleSubmit = async data => {
    return entityManager.onSubmit({
      id: data.id,
      telefone: data.telefone
    })
  }

  return (
    <CrudForm
      {...props}
      {...entityManager}
      onGoBack={history.goBack}
      onSubmit={handleSubmit}
      withPaper
    >
      <Grid container spacing={2}>
        <Grid item sm={4} xs={12}>
          <Field
            fullWidth
            disabled
            name="nome"
            label="Nome"
            component={TextField}
          />
        </Grid>
        <Grid item sm={4} xs={12}>
          <Email disabled />
        </Grid>
        <Grid item sm={4} xs={12}>
          <Field
            fullWidth
            name="telefone"
            label="Telefone"
            InputLabelProps={{ shrink: true }}
            format={parseTelefone}
            component={TextField}
          />
        </Grid>
      </Grid>
    </CrudForm>
  )
}

export default UsuarioSimpleForm
